<template>
	<div class="main-content">
		<!-- 列表页 -->
		<el-form class="center-form-pv" :inline="true" :model="searchForm">
			<el-row>
				<div style="margin:0 10px 0 0;display:inline-block">
					<label class="item-label">工号</label>
					<el-input v-model="searchForm.gonghao" placeholder="工号" @keydown.enter.native="search()" clearable></el-input>
				</div>
				<div style="margin:0 10px 0 0;display:inline-block">
					<label class="item-label">姓名</label>
					<el-input v-model="searchForm.xingming" placeholder="姓名" @keydown.enter.native="search()" clearable></el-input>
				</div>
				<div style="margin:0 10px 0 0;display:inline-block">
					<label class="item-label">审核状态</label>
					<el-select clearable v-model="searchForm.shenheStatus" placeholder="请选择审核状态">
						<el-option label="待审核" value="待审核"></el-option>
						<el-option label="审核通过" value="审核通过"></el-option>
						<el-option label="审核不通过" value="审核不通过"></el-option>
					</el-select>
				</div>
				<el-button class="search" type="success" @click="search()">
					搜索
				</el-button>
			</el-row>

			<el-row class="actions" style="margin:20px 0">
				<el-button class="del" :disabled="dataListSelections.length?false:true" type="danger" @click="deleteHandler()">
					删除
				</el-button>
			</el-row>
		</el-form>
		
		<div style="width:100%;background:#fff">
			<el-table 
				class="tables"
				:border='true'
				:data="dataList"
				v-loading="dataListLoading"
				@selection-change="selectionChangeHandler">
				<el-table-column type="selection" align="center" width="50"></el-table-column>
				<el-table-column label="序号" type="index" width="50" />
				<el-table-column prop="gonghao" label="工号" min-width="120">
					<template slot-scope="scope">
						{{scope.row.gonghao}}
					</template>
				</el-table-column>
				<el-table-column prop="xingming" label="姓名" min-width="100">
					<template slot-scope="scope">
						{{scope.row.xingming}}
					</template>
				</el-table-column>
				<el-table-column prop="xingbie" label="性别" min-width="80">
					<template slot-scope="scope">
						{{scope.row.xingbie}}
					</template>
				</el-table-column>
				<el-table-column prop="nianling" label="年龄" min-width="80">
					<template slot-scope="scope">
						{{scope.row.nianling}}
					</template>
				</el-table-column>
				<el-table-column prop="shouji" label="手机" min-width="120">
					<template slot-scope="scope">
						{{scope.row.shouji}}
					</template>
				</el-table-column>
				<el-table-column prop="bumen" label="部门" min-width="120">
					<template slot-scope="scope">
						{{scope.row.bumen}}
					</template>
				</el-table-column>
				<el-table-column prop="shenheStatus" label="审核状态" min-width="120">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.shenheStatus === '待审核'" type="warning">待审核</el-tag>
						<el-tag v-else-if="scope.row.shenheStatus === '审核通过'" type="success">审核通过</el-tag>
						<el-tag v-else-if="scope.row.shenheStatus === '审核不通过'" type="danger">审核不通过</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="addtime" label="申请时间" min-width="160">
					<template slot-scope="scope">
						{{scope.row.addtime}}
					</template>
				</el-table-column>
				<el-table-column label="操作" width="280" fixed="right">
					<template slot-scope="scope">
						<el-button class="view" type="success" size="small" @click="viewDetail(scope.row)">
							查看
						</el-button>
						<el-button 
							v-if="scope.row.shenheStatus === '待审核'" 
							class="edit" 
							type="primary" 
							size="small" 
							@click="openShenheDialog(scope.row)">
							审核
						</el-button>
						<el-button class="del" type="danger" size="small" @click="deleteHandler(scope.row.id)">
							删除
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		
		<el-pagination
			@size-change="sizeChangeHandle"
			@current-change="currentChangeHandle"
			:current-page="pageIndex"
			background
			:page-sizes="[10, 20, 30, 50]"
			:page-size="pageSize"
			layout="total, sizes, prev, pager, next, jumper"
			:total="totalPage"
			style="margin:20px 0 0"
		></el-pagination>
		
		<!-- 审核弹窗 -->
		<el-dialog 
			title="员工注册审核" 
			:visible.sync="shenheDialogVisible" 
			width="600px"
			:close-on-click-modal="false">
			<el-form :model="shenheForm" label-width="120px">
				<el-form-item label="工号">
					<span>{{currentRow.gonghao}}</span>
				</el-form-item>
				<el-form-item label="姓名">
					<span>{{currentRow.xingming}}</span>
				</el-form-item>
				<el-form-item label="性别">
					<span>{{currentRow.xingbie}}</span>
				</el-form-item>
				<el-form-item label="年龄">
					<span>{{currentRow.nianling}}</span>
				</el-form-item>
				<el-form-item label="手机">
					<span>{{currentRow.shouji}}</span>
				</el-form-item>
				<el-form-item label="部门">
					<span>{{currentRow.bumen}}</span>
				</el-form-item>
				<el-form-item label="申请时间">
					<span>{{currentRow.addtime}}</span>
				</el-form-item>
				<el-form-item label="审核结果" required>
					<el-radio-group v-model="shenheForm.status">
						<el-radio label="审核通过">审核通过</el-radio>
						<el-radio label="审核不通过">审核不通过</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item 
					v-if="shenheForm.status === '审核不通过'" 
					label="不通过原因" 
					required>
					<el-input 
						type="textarea" 
						:rows="4"
						v-model="shenheForm.reason" 
						placeholder="请输入不通过原因">
					</el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="shenheDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitShenhe">确 定</el-button>
			</div>
		</el-dialog>
		
		<!-- 详情弹窗 -->
		<el-dialog 
			title="员工注册详情" 
			:visible.sync="detailDialogVisible" 
			width="600px">
			<el-form label-width="140px">
				<el-form-item label="工号">
					<span>{{currentRow.gonghao}}</span>
				</el-form-item>
				<el-form-item label="姓名">
					<span>{{currentRow.xingming}}</span>
				</el-form-item>
				<el-form-item label="性别">
					<span>{{currentRow.xingbie}}</span>
				</el-form-item>
				<el-form-item label="年龄">
					<span>{{currentRow.nianling}}</span>
				</el-form-item>
				<el-form-item label="手机">
					<span>{{currentRow.shouji}}</span>
				</el-form-item>
				<el-form-item label="部门">
					<span>{{currentRow.bumen}}</span>
				</el-form-item>
				<el-form-item label="头像" v-if="currentRow.touxiang">
					<img v-if="currentRow.touxiang.substring(0,4)=='http'" :src="currentRow.touxiang" width="100" height="100">
					<img v-else :src="$base.url+currentRow.touxiang" width="100" height="100">
				</el-form-item>
				<el-form-item label="申请时间">
					<span>{{currentRow.addtime}}</span>
				</el-form-item>
				<el-form-item label="审核状态">
					<el-tag v-if="currentRow.shenheStatus === '待审核'" type="warning">待审核</el-tag>
					<el-tag v-else-if="currentRow.shenheStatus === '审核通过'" type="success">审核通过</el-tag>
					<el-tag v-else-if="currentRow.shenheStatus === '审核不通过'" type="danger">审核不通过</el-tag>
				</el-form-item>
				<el-form-item label="审核时间" v-if="currentRow.shenheTime">
					<span>{{currentRow.shenheTime}}</span>
				</el-form-item>
				<el-form-item label="不通过原因" v-if="currentRow.shenheYijian">
					<span style="color:#f56c6c">{{currentRow.shenheYijian}}</span>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="detailDialogVisible = false">关 闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			searchForm: {
				gonghao: '',
				xingming: '',
				shenheStatus: ''
			},
			dataList: [],
			dataListLoading: false,
			dataListSelections: [],
			pageIndex: 1,
			pageSize: 10,
			totalPage: 0,
			shenheDialogVisible: false,
			detailDialogVisible: false,
			currentRow: {},
			shenheForm: {
				status: '审核通过',
				reason: ''
			}
		}
	},
	mounted() {
		this.getDataList();
	},
	methods: {
		search() {
			this.pageIndex = 1;
			this.getDataList();
		},
		// 获取数据列表
		getDataList() {
			this.dataListLoading = true
			let params = {
				page: this.pageIndex,
				limit: this.pageSize,
				sort: 'addtime',
				order: 'desc'
			}
			if(this.searchForm.gonghao) params.gonghao = this.searchForm.gonghao;
			if(this.searchForm.xingming) params.xingming = '%' + this.searchForm.xingming + '%';
			if(this.searchForm.shenheStatus) params.shenheStatus = this.searchForm.shenheStatus;
			
			this.$http({
				url: "yuangongregister/page",
				method: "get",
				params: params
			}).then(({ data }) => {
				if (data && data.code === 0) {
					this.dataList = data.data.list
					this.totalPage = data.data.total
				} else {
					this.dataList = []
					this.totalPage = 0
				}
				this.dataListLoading = false
			})
		},
		// 每页数
		sizeChangeHandle(val) {
			this.pageSize = val
			this.pageIndex = 1
			this.getDataList()
		},
		// 当前页
		currentChangeHandle(val) {
			this.pageIndex = val
			this.getDataList()
		},
		// 多选
		selectionChangeHandler(val) {
			this.dataListSelections = val
		},
		// 查看详情
		viewDetail(row) {
			this.currentRow = row;
			this.detailDialogVisible = true;
		},
		// 打开审核弹窗
		openShenheDialog(row) {
			this.currentRow = row;
			this.shenheForm = {
				status: '审核通过',
				reason: ''
			};
			this.shenheDialogVisible = true;
		},
		// 提交审核
		submitShenhe() {
			if(this.shenheForm.status === '审核不通过' && !this.shenheForm.reason) {
				this.$message.error('请填写不通过原因');
				return;
			}
			
			this.$http({
				url: "yuangongregister/shenhe",
				method: "post",
				data: {
					id: this.currentRow.id,
					status: this.shenheForm.status,
					reason: this.shenheForm.reason
				}
			}).then(({ data }) => {
				if (data && data.code === 0) {
					this.$message({
						message: data.msg || '审核成功',
						type: 'success',
						duration: 1500,
						onClose: () => {
							this.shenheDialogVisible = false;
							this.getDataList();
						}
					})
				} else {
					this.$message.error(data.msg || '审核失败');
				}
			})
		},
		// 删除
		deleteHandler(id) {
			var ids = id ? [id] : this.dataListSelections.map(item => {
				return item.id
			})
			this.$confirm(`确定删除所选的${ids.length}条数据?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: "yuangongregister/delete",
					method: "post",
					data: ids
				}).then(({ data }) => {
					if (data && data.code === 0) {
						this.$message({
							message: '删除成功',
							type: 'success',
							duration: 1500
						})
						this.getDataList()
					} else {
						this.$message.error(data.msg || '删除失败')
					}
				})
			})
		}
	}
}
</script>

<style lang="scss" scoped>
.main-content {
	color: #666;
	padding: 20px 30px 30px;
	font-size: 16px;
}

.item-label {
	margin: 0 10px 0 0;
	display: inline-block;
	line-height: 40px;
	font-size: inherit;
	font-weight: 500;
	height: 40px;
}

.actions {
	flex-wrap: wrap;
	margin: 20px 0;
	display: flex;
}

.tables {
	padding: 0;
	border-color: #eee;
	color: inherit;
	border-width: 1px 0 0 1px;
	background: #fff;
	width: 100%;
	font-size: inherit;
	border-style: solid;
}

/* 覆盖Element UI的success绿色为青蓝色 #56B2C6 */
.el-button--success {
    background-color: #56B2C6 !important;
    border-color: #56B2C6 !important;
}

.el-button--success:hover,
.el-button--success:focus {
    background-color: #68bdd2 !important;
    border-color: #68bdd2 !important;
}

.el-tag--success {
    background-color: rgba(86,178,198,.1) !important;
    border-color: rgba(86,178,198,.2) !important;
    color: #56B2C6 !important;
}

</style>

